import script from "./StepResetLinkSent.vue?vue&type=script&setup=true&lang=js"
export * from "./StepResetLinkSent.vue?vue&type=script&setup=true&lang=js"

import "./StepResetLinkSent.vue?vue&type=style&index=0&id=2c995e38&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c995e38"]])

export default __exports__